var p2000 = angular.module('p2000', ['ngAnimate']);

p2000.controller('P2000Ctrl', ['$scope', '$http', '$interval', function($scope, $http, $interval) {

	var REFRESH_INTERVAL = 5000;

	$http.get('/rest/filters/regio').then(function(response) {
		$scope.regions = response.data;
	});

	$http.get('/rest/filters/filter').then(function(response) {
		$scope.filters = response.data;
	});

	if (!$scope.errorPage) {
		var restUrl = "/rest/alarms";
		var loaded = false;

		if ($scope.pageType !== '') {
			restUrl += "/" + $scope.pageType + "/" + $scope.filterCode;
		} else {
			restUrl += "/all";
		}

		setTimeout(function() {
			if (!loaded) {
				$scope.showLoadingBar = true;
				$scope.$apply();
			}
		}, 500);

		$http.get(restUrl).then(function(response) {
			loaded = true;
			$scope.alarmeringen = response.data;
			$scope.showLoadingBar = false;
			$scope.loadFinished = true;
		});

		if (window.WebSocket) { // browser supports websockets

			var wsProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
			var wsUrl = wsProtocol + '//' + window.location.host + '/websocket/alarmeringen';

			if ($scope.pageType != '') {
				wsUrl += '/' + $scope.pageType + '/' + $scope.filterCode
			} else {
				wsUrl += '/all/';
			}
			var websocket = new ReconnectingWebSocket(wsUrl);


			websocket.onmessage = function(evt) {
				var alarmering = angular.fromJson('[' + evt.data + ']');

				$scope.p2000Update = true;
				$scope.alarmeringen = alarmering.concat($scope.alarmeringen);
				$scope.$apply();
			};

			websocket.onerror = function(evt) {
				console.log('Error in Websocket communication',evt);
			};
		} else { // fall back to polling
			$interval(function() {
				var url;
				if ($scope.alarmeringen.length > 0) {
					var lastId = $scope.alarmeringen[0].id;
					url = restUrl + '?lastId=' + lastId;
				} else {
					url = restUrl;
				}

				$http.get(url).then(function(response) {
					$scope.p2000Update = true;
					$scope.alarmeringen = response.data.concat($scope.alarmeringen);
				});
			}, REFRESH_INTERVAL);
		}
	}
}]);

p2000.directive('p2000UpdateAnimation',[ '$animate', function($animate) {
	return function($scope, $element, $attrs) {
		if ($scope.p2000Update) {
			$element.addClass("animate");
			$scope.p2000Update = false;
		}
	}
} ]);